import { createAction, props } from '@ngrx/store';
import { MemberNote } from './member-notes.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records member note',
    props<{memberId: string}>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records member note success', 
    props<{ listData: MemberNote[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records member note failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record member note',
    props<{memberId: string, id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record member note success', 
    props<{ singleData: MemberNote }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record member note failure', 
    props<{ error: string }>()
);

// Add Data
export const addRecord = createAction(
    '[Data] Add record member note',
    props<{ memberId: string, newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record member note success'
);
export const addRecordFailure = createAction(
    '[Data] Add record member note failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record member note',
    props<{ memberId: string, id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record member note success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record member note failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record member note',
    props<{ memberId: string, id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record member note success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record member note failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state member note',
);